<section class="suggestion-section" *ngIf="restaurantProduct && restaurantProduct.length">
  <div class="suggestion-title">
    Suggested add ons
  </div>
  <div class="item-container">
    <div *ngFor="let product of restaurantProduct" class="item-wrap" (click)="showProductModal(product)">
      <img class="item-img" [src]="imageUrl(product)">
      <div class="item-info">
        {{product.info.name}}
        <ng-container *ngIf="getPriceRange(product).length === 2; else productWithOnePrice">
         <span class="price-info">
           {{currencySign}}{{getFormattedPrice(getPriceRange(product)[0])}} &ndash; {{currencySign}}{{getFormattedPrice(getPriceRange(product)[1])}}
         </span>
        </ng-container>

        <ng-template #productWithOnePrice>
              <span class="price-info">
                {{currencySign}}{{getFormattedPrice(getPriceWithModifiers(product))}}
              </span>
        </ng-template>
      </div>
    </div>
  </div>
</section>

<app-product-modal
  [defaultProduct]="selectedProduct"
  [restaurant]="restaurant"
  [locationId]="locationId"
  [isMobileEnabled]="restaurant?.isMobileEnabled"
  [isModal]="true"
  [enforceInventory]="restaurant?.enforceInventory"
  [hoursOfOperation]="restaurant?.hoursOfOperation"
  [allowScheduledPickups]="restaurant.allowScheduledPickups"
  [isClosed]="false"
  [isRestaurantHaveEnabledWorkDays]="true"
  *ngIf="isShowProductModal"
  (close)="closeProductModal()"
  (addItem)="onAddItemToCart($event)"
>
</app-product-modal>
